import { createAction } from "@reduxjs/toolkit";
import License from "spectral-core/models/License";

export const setLicensesAction =
  createAction<License[]>("SET_LICENSES");

export const setLicensesLogoutAction = 
  createAction("LOGOUT");